var App = App || {};

App.Separators = (function () {
    "use strict";

    var separatedLists = document.querySelectorAll(".separated-list");

    function init() {
        var separatedElements = [];

        separatedLists.forEach(function (list) {
            var listItems = Array.prototype.filter.call(list.children, function (child) {
                return child.matches("li, .separated-list-item");
            });

            if (listItems.length) {
                separatedElements.push(listItems);
            }
        });

        applySeparatorsToGroup(separatedElements);

        window.addEventListener("resize", function () {
            applySeparatorsToGroup(separatedElements);
        });

        document.querySelectorAll(".offcanvas").forEach(function (offcanvas) {
            offcanvas.addEventListener("shown.bs.offcanvas", function () {
                applySeparatorsToGroup(separatedElements);
            });
        });

        document.querySelectorAll(".accordion").forEach(function (accordion) {
            accordion.addEventListener("shown.bs.collapse", function () {
                applySeparatorsToGroup(separatedElements);
            });

            accordion.addEventListener("hidden.bs.collapse", function () {
                applySeparatorsToGroup(separatedElements);
            });
        });
    }

    function applySeparatorsToGroup(elementGroup) {
        if (elementGroup.length) {
            for (var i = 0; i < elementGroup.length; i++) {
                applySeparators(elementGroup[i]);
            }
        }
    }

    function applySeparators(elements) {
        elements.forEach(function (element) {
            element.classList.remove("separated");
        });

        if (elements.length) {
            var currentLineTop = null;

            elements.forEach(function (element) {
                var currentItemTop = element.offsetTop;

                if (currentItemTop === currentLineTop) {
                    element.classList.add("separated");
                } else {
                    currentLineTop = currentItemTop;
                }
            });
        }
    }

    return {
        init: init
    };
})();

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        App.Separators.init();
    });
} else {
    App.Separators.init();
}